<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">

            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> Listado de Documentaciones para la Campaña
            </div>

            <div class="card-body-grid">

                <p-table #tableSearch autoLayout="true" [value]="documentos"
                            [columns]="cols" sortField="IdTipoDocumentacionDescripcion" sortOrder="-1"
                            styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                            [ngClass]="displayGridHidden(documentos)">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex" >
                        <tr [ngClass]="{'text-muted': rowData.MarkToDelete === 1}">
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">

                                <span *ngIf="(col.field!=='Link') && col.field!=='Obligatoria'" [disabled]="active === false">
                                    {{rowData[col.field]}}
                                </span>
                                <span *ngIf="col.field==='Obligatoria'">
                                    {{rowData[col.field] | siNo}}
                                </span>
                                <div *ngIf="col.field==='Link' && (rowData.MarkToDelete === undefined || rowData.MarkToDelete === 0)" class="btn-group">
                                    <button (click)="onDelete(rowData)" type="button" class="btn btn-sm btn-danger" title="Eliminar">
                                        <span class="fa fa-remove"></span>
                                    </button>
                                </div>
                                <div *ngIf="col.field==='Link' && rowData.MarkToDelete === 1" class="btn-group">
                                    <button (click)="onUndoDelete(rowData)" type="button" class="btn btn-sm btn-warning" title="Deshacer" [disabled]="!adjuntarDocumentacion">
                                        <span class="fa fa-undo"></span>
                                    </button>
                                </div>

                            </td>
                        </tr>
                    </ng-template>

                </p-table>
                <div *ngIf="documentos?.length === 0" class="empty-grid">
                    No hay documentos asociados a la Campaña
                </div>
            </div>
        </div>
    </div>
</div>
